export const wideMenuMinWidth = '174px';
export const regularMenuMinWidth = '160px';
export const skinnyMenuMinWidth = '110px';
export const extraWideMenuMinWidth = '214px';
